import * as Yup from 'yup';
import {
  NUMBER_TYPE_ERROR_MSG,
  VEHICLE_NUMBER_REGEX
} from 'src/utils/constants';
import { getMaxLengthErrorMsg, getMaxLimitErrorMsg } from 'src/utils/getInitials';
import externalTransactionFormModel from './externalTransactionFormModel';

const {
  formField: {
    siteId,
    quantity,
    unitPrice,
    amount,
    vehicleNumber,
    dateTime,
    odometerEntry
  }
} = externalTransactionFormModel;

export default Yup.object().shape({
  [siteId.name]: Yup.string().required(siteId.requiredErrorMsg),
  [quantity.name]: Yup.number().max(99999, getMaxLimitErrorMsg(quantity, 99999))
    .typeError(NUMBER_TYPE_ERROR_MSG).required(quantity.requiredErrorMsg),
  [unitPrice.name]: Yup.number().max(99999, getMaxLimitErrorMsg(unitPrice, 99999))
    .typeError(NUMBER_TYPE_ERROR_MSG).required(unitPrice.requiredErrorMsg),
  [amount.name]: Yup.number().max(999999999, getMaxLimitErrorMsg(amount, 999999999))
    .typeError(NUMBER_TYPE_ERROR_MSG).required(amount.requiredErrorMsg),
  [vehicleNumber.name]: Yup.string().max(100, getMaxLengthErrorMsg(vehicleNumber, 100))
    .matches(VEHICLE_NUMBER_REGEX, vehicleNumber.invalidErrorMsg)
    .required(vehicleNumber.requiredErrorMsg),
  [dateTime.name]: Yup.date().required(dateTime.requiredErrorMsg),
  [odometerEntry.name]: Yup.number().min(0).max(999999999, getMaxLimitErrorMsg(odometerEntry, 999999999))
    .typeError(NUMBER_TYPE_ERROR_MSG)
    .required(odometerEntry.requiredErrorMsg),
});
